import React from "react";
import wslogo from '../assets/whatsapplogo-gold.svg';

const QueHacemos = () => {
  return (
    <main className="landing-page">
      <section className="lp-hero">
        <p className="lp-kicker">Desarrollo de software a medida</p>
        <h1>Mejoramos y optimizamos procesos con tecnología aplicada al negocio</h1>
        <p className="lp-subtitle">
          Diseñamos soluciones web que eliminan tareas manuales, conectan sistemas y
          entregan visibilidad operativa para tomar mejores decisiones.
        </p>
        <div className="lp-hero-actions">
          <a className="lp-btn lp-btn-primary" href="https://wa.me/56996269600" rel="noreferrer" target="_blank">
            Hablemos por WhatsApp
          </a>
          <a className="lp-btn lp-btn-secondary" href="https://www.linkedin.com/in/cokeghm/" rel="noreferrer" target="_blank">
            Ver trayectoria
          </a>
        </div>
      </section>

      <section className="lp-grid">
        <article className="lp-card">
          <h3>Automatización de procesos</h3>
          <p>
            Convertimos flujos repetitivos en procesos automatizados para reducir tiempos,
            errores operativos y costos.
          </p>
        </article>
        <article className="lp-card">
          <h3>Integraciones a medida</h3>
          <p>
            Conectamos ERP, APIs de terceros, e-commerce y plataformas internas para
            lograr una operación realmente integrada.
          </p>
        </article>
        <article className="lp-card">
          <h3>Dashboards y analítica</h3>
          <p>
            Creamos paneles de control con indicadores clave para monitorear resultados
            y detectar oportunidades de mejora continua.
          </p>
        </article>
      </section>

      <section className="lp-section">
        <h2>Cómo trabajamos</h2>
        <div className="lp-steps">
          <div>
            <span>01</span>
            <h4>Diagnóstico del proceso</h4>
            <p>Levantamiento de cuellos de botella, riesgos y tareas de alto impacto.</p>
          </div>
          <div>
            <span>02</span>
            <h4>Diseño de la solución</h4>
            <p>Definición de alcance, arquitectura y roadmap enfocado en resultados.</p>
          </div>
          <div>
            <span>03</span>
            <h4>Implementación y mejora</h4>
            <p>Desarrollo iterativo, medición continua y optimización tras el lanzamiento.</p>
          </div>
        </div>
      </section>

      <section className="lp-section lp-about">
        <h2>Experiencia combinando negocio y tecnología</h2>
        <p>
          En Thovex combinamos visión de negocio y desarrollo técnico: plataformas B2B,
          integraciones, datos y automatización para que tu operación sea más eficiente y escalable.
        </p>
        <p>
          Stack habitual: React, TypeScript, Node.js, Python, PostgreSQL, Firebase, GCP y Railway.
          Enfoque en software a medida para operaciones comerciales, financieras e industriales.
        </p>
      </section>

      <section className="lp-section lp-cta">
        <h2>Conversemos tu proyecto</h2>
        <p>
          Si hoy tienes procesos manuales, información dispersa o sistemas desconectados,
          podemos ayudarte a convertirlos en una operación eficiente y escalable.
        </p>
        <a className="lp-btn lp-btn-primary" href="https://wa.me/56996269600" rel="noreferrer" target="_blank">
          Solicitar reunión inicial
        </a>
      </section>

      <div className="lp-floating-contact">
        <a href="https://wa.me/56996269600" rel="noreferrer" target="_blank" aria-label="Contactar por WhatsApp">
          <img className="logo-whatsapp" src={wslogo} alt="Logo Whatsapp" />
        </a>
      </div>
    </main>
  );
};

export default QueHacemos;
